import React from "react";
import { Navigate } from "react-router-dom";
import { userStore } from "../../stores";
import { setReturnUrl } from "../../appHistory";

export function AuthenticatedRoute({ children }: { children: JSX.Element }) {

  if (userStore.isStoredAccessTokenValid()) {
    return children
  } else {
    setReturnUrl();
    return <Navigate to="/login" replace={true} />
  }
}